<template>
  <div class="basic">
    <van-collapse v-model="activeNames">
      <van-collapse-item title="合同信息" name="1">
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.conunit"
            label="签约单位"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.contype"
            label="合同类型"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.conproperty"
            label="合同属性"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.createdate"
            label="入职日期"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.comyear"
            label="司龄"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.probdate"
            label="转正日期"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            label-width="100"
            v-model="contractInfo.conbegindate"
            label="合同开始时间"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            label-width="100"
            v-model="contractInfo.conenddate"
            label="合同结束时间"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.conterm"
            label="合同期(月)"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            label-width="100"
            v-model="contractInfo.concount"
            label="合同签约次数"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.probterm"
            label="试用期"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.probenddate"
            label="拟转正日期"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis";
import { getToken } from "@/utils/cookie";
// import { onUpdated } from 'vue';
export default {
  name: "basic",
  data() {
    return {
      activeNames: ["1"],
      tagList: [],
      //合同信息
      contractInfo: {},
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    //获取合同信息
    getList() {
      api.getSelectByEmpNo({ empNo: getToken() }).then((data) => {
        this.tagList = data.data;
        this.contractInfo = this.tagList.contractInfo;
        this.contractInfo.conbegindate = moment(
          this.contractInfo.conbegindate
        ).format("YYYY-MM-DD");
        this.contractInfo.conenddate = moment(
          this.contractInfo.conenddate
        ).format("YYYY-MM-DD");
        this.contractInfo.createdate = moment(
          this.contractInfo.createdate
        ).format("YYYY-MM-DD");
        this.contractInfo.probdate = moment(this.contractInfo.probdate).format(
          "YYYY-MM-DD"
        );
        this.contractInfo.probenddate = moment(
          this.contractInfo.probenddate
        ).format("YYYY-MM-DD");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .basic {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .basic {
    width: 276px * $zoom;
  }
}
.basic {
  background: #f4f5f8;
  font-size: 16px * $zoom;
  min-height: 100vh;
  padding: 0 20px;
  ::v-deep .van-picker__toolbar {
    height: 40px * $zoom;
    .van-picker__cancel {
      font-size: 0.42667rem;
    }
    .van-picker__confirm {
      font-size: 16px * $zoom;
    }
  }
  ::v-deep .van-ellipsis {
    font-size: 8px * $zoom;
  }
  .van-collapse-item {
    margin-top: 5px * $zoom;
    background: none;
  }
  ::v-deep .van-cell__title span {
    font-size: 12px * $zoom;
    border-left: 6px solid #018755;
    padding-left: 15px;
  }
  ::v-deep .van-field {
    span {
      font-size: 10px * $zoom;
      border: none;
      padding-left: 0;
    }
  }
  ::v-deep .van-cell {
    display: flex;
    justify-content: space-between;
    border-radius: 15px;
  }
  ::v-deep van-collapse-item__title {
    .van-cell__title span {
      font-size: 20px * $zoom !important;
    }
  }
  ::v-deep .van-collapse-item__content {
    background: none;
    padding: 12px 0 0 0;
  }
  .conTitle {
    background: #fff;
    border-radius: 2px * $zoom;
    ::v-deep .van-cell__title span {
      font-size: 10px * $zoom;
      border: none;
      padding-left: 0;
    }
  }
}
</style>
